import React from 'react';
import {
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { SentFileListProps } from '../../types/message';
import { SentFileItem } from './SentFileItem';

/**
 * 送信済みファイルリスト表示コンポーネント
 * チャットメッセージに添付された複数ファイルをリスト表示
 */
export const SentFileList: React.FC<SentFileListProps> = ({
  files,
  onDownload,
}) => {
  const theme = useTheme();

  if (!files || files.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 1, mb: 0.5 }}>
      {/* ファイル数表示 */}
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontSize: '0.75rem',
          mb: 0.5,
          display: 'block',
        }}
      >
        添付ファイル ({files.length}個)
      </Typography>

      {/* ファイルリスト */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}
      >
        {files.map((file) => (
          <SentFileItem
            key={file.id}
            file={file}
            onDownload={onDownload}
          />
        ))}
      </Box>
    </Box>
  );
}; 